// extracted by mini-css-extract-plugin
export default {"root":"Bible_root__Cj9sc","layout-container":"Bible_layout-container__GvdMa","bibleContainer":"Bible_bibleContainer__05Gsw","description":"Bible_description__hQE6e","editing":"Bible_editing__WJFC8","overLimit":"Bible_overLimit__LVdvM","errorText":"Bible_errorText__egdCW","textContainer":"Bible_textContainer__N+2ea"};
    if(module.hot) {
      // 1763446808824
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  